<template>
  <div
    v-if="records.length"
    class="tank-chart-container"
    :title="expand && 'クリックして拡大'"
    :style="expand && 'cursor: pointer;'"
    @click="showSensorDialog = expand && !!records.length"
  >
    <LineChart
      :chart-data="chartData"
      :options="options"
      :styles="styles"
    />
    <v-dialog
      v-model="showSensorDialog"
      content-class="tank-chart-dialog"
    >
      <BigTankChart
        v-if="showSensorDialog"
        :customer="customer"
        :tank="tank"
      />
    </v-dialog>
  </div>
  <div
    v-else
    class="no-records-text"
  >
    センサーデータがありません
  </div>
</template>

<script>
import LineChart from './LineChart'

export default {
  name: 'TankChart',
  components: {
    LineChart,
    BigTankChart: () => import('./BigTankChart')
  },
  props: {
    customer: {
      type: Object,
      default: () => null
    },
    tank: {
      type: Object,
      default: () => null
    },
    expand: {
      type: Boolean,
      default: () => false
    },
    minDate: {
      type: Date,
      default: () => null
    },
    maxDate: {
      type: Date,
      default: () => null
    },
    records: {
      type: Array,
      default: () => []
    },
    legend: {
      type: Boolean,
      default: () => true
    },
    maintainAspectRatio: {
      type: Boolean,
      default: () => true
    }
  },
  data () {
    return {
      showSensorDialog: false,
      styles: {
        height: '100%',
        width: '100%'
      }
    }
  },
  computed: {
    options () {
      const now = new Date()
      now.setHours(0, 0, 0, 0)
      const today = now.getTime()

      return {
        responsive: true,
        maintainAspectRatio: this.maintainAspectRatio,
        legend: {
          display: this.legend
        },
        animation: false,
        scales: {
          xAxes: [{
            type: 'time',
            distribution: 'linear',
            time: {
              unit: 'day',
              displayFormats: {
                day: 'M/D'
              }
            },
            bounds: 'ticks',
            ticks: {
              min: this.minDate || new Date(today - 7 * 24 * 60 * 60 * 1000),
              max: this.maxDate || new Date(today + 1 * 24 * 60 * 60 * 1000)
            }
          }],
          yAxes: [{
            ticks: {
              min: 0,
              suggestedMax: this.getMaxLine(this.tank.maxVolume)
            }
          }]
        }
      }
    },
    chartData () {
      const maxVolume = this.tank.oilMaxVolume
      const threshold = this.tank.volumeThreshold

      const records = []
      const maxLines = []
      const thresholdLines = []

      for (const record of this.records) {
        const t = new Date(record.timestamp * 1000)

        records.push({ t, y: Math.min(maxVolume, record.oilVolume) })
        maxLines.push({ t, y: maxVolume })
        thresholdLines.push({ t, y: threshold })
      }
      return {
        datasets: [{
          label: '残量',
          data: records,
          backgroundColor: '#54d458',
          borderColor: 'rgb(52, 131, 55)',
          borderWidth: 3,
          pointRadius: 1
        }, {
          label: '最大値',
          data: maxLines,
          pointRadius: 0,
          borderColor: '#bbb',
          backgroundColor: 'transparent'
        },
        {
          label: 'しきい値',
          data: thresholdLines,
          pointRadius: 0,
          borderColor: '#FF5252',
          backgroundColor: 'rgba(255, 82, 82, 0.9)'
        }]
      }
    }
  },
  methods: {
    getMaxLine (volume) {
      if (volume > 500) {
        return 1050
      }
      if (volume > 300) {
        return 550
      }
      return 350
    }
  }
}
</script>
<style lang="scss" scoped>
.tank-chart-container {
  height: 100%;
  width: 100%;
}
.no-records-text{
  text-align: center;
  padding: 45% 0;
}
</style>

<style lang="scss">
.tank-chart-dialog {
  width: auto;
  max-height: unset!important;
}
</style>
